import styled from 'styled-components'
import { ShopTheLookButton } from '@velasca/ui/shop-the-look-button'

export const ShopButton = styled(ShopTheLookButton)`
  position: absolute;
  bottom: 1.2rem;
  left: 1.5rem;
  z-index: 1;
`
